/**
 * transitions.js — Cross-Document View Transitions (Lenis Integration)
 *
 * The transition itself is purely CSS-driven (@view-transition in
 * transitions.css). This module only handles the Lenis smooth-scroll
 * lifecycle during page swaps:
 *
 *   pageswap (old page) → destroy Lenis so its RAF loop doesn't shift
 *     the scroll position while the browser captures the exit snapshot.
 *
 *   pageshow with event.persisted (back/forward cache restore) → the page
 *     comes back with its JS state frozen at the moment of the pageswap
 *     above, i.e. Lenis already destroyed, and DOMContentLoaded does not
 *     fire again. Re-create Lenis and re-attach the parallax listeners.
 *
 * A freshly loaded page re-initialises Lenis from main.js on
 * DOMContentLoaded, so the forward direction needs no special handling.
 */

import { getLenis, initLenis } from "./lenis.js";
import { rebindParallax } from "./parallax.js";

/**
 * Register lifecycle hooks for view transitions.
 * Only runs setup if the browser supports MPA view transitions
 * (the pageswap event only fires in supporting browsers).
 */
export function initTransitions() {
  window.addEventListener("pageswap", () => {
    const lenis = getLenis();
    if (lenis) {
      lenis.destroy();
      window.lenis = null;
    }
  });

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return;
    initLenis();
    rebindParallax();
  });
}
